import { clearErrors } from '../../errors';
import { escapeRegex } from '../../string';
import { getError } from '..';

import { ENABLED, REQUIRED, VALUE } from '../../../constants/product';
import { OPERATIONS } from '../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../constants/attributes';
import { FORM } from '../../../constants/forms';

export default function personalization({ actions, operation, product }) {
  const channel = product.get('channel');

  function validateAndApply({ type, value }) {
    return {
      actions,
      product: getError({ channel, type, value })
        ? product
        : clearErrors({
          errors: [type],
          path: FORM.PERSONALIZATION,
          product: product.set(FORM.PERSONALIZATION,
            product.get(FORM.PERSONALIZATION).setIn([type, VALUE], value)
          ),
        }),
    };
  }

  switch (operation.get('type')) {
    case OPERATIONS[channel].PERSONALIZATION.IS_PERSONALIZABLE_SET: {
      return {
        actions,
        product: product.setIn([FORM.PERSONALIZATION, ENABLED], operation.get('value')),
      };
    }

    case OPERATIONS[channel].PERSONALIZATION.IS_REQUIRED_SET: {
      return {
        actions,
        product: product.setIn([FORM.PERSONALIZATION, REQUIRED], operation.get('value')),
      };
    }

    case OPERATIONS[channel].PERSONALIZATION.CHAR_COUNT_MAX_SET: {
      return validateAndApply({
        type: ATTRIBUTE.CHAR_COUNT_MAX,
        value: operation.get('value'),
      });
    }

    case OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_SET: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: operation.get('value') || '',
      });
    }

    case OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_DELETE: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: product
          .getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])
          .replace(new RegExp(escapeRegex(operation.get('value')), 'ig'), ''),
      });
    }

    case OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_ADD_AFTER: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: `${product.getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])}${operation.get('value')}`,
      });
    }

    case OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_ADD_BEFORE: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: `${operation.get('value')}${product.getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])}`,
      });
    }

    case OPERATIONS[channel].PERSONALIZATION.INSTRUCTIONS_FIND_AND_REPLACE: {
      return validateAndApply({
        type: ATTRIBUTE.INSTRUCTIONS,
        value: product
          .getIn([FORM.PERSONALIZATION, ATTRIBUTE.INSTRUCTIONS, VALUE])
          .replace(
            new RegExp(escapeRegex(operation.getIn(['value', 'find'])), 'ig'),
            operation.getIn(['value', 'replace'])
          ),
      });
    }

    default: {
      return { actions, product };
    }
  }
}
